import * as types from "../constants/actionTypes";
import { getClubLoggedUserDataFromApi } from "../api/registration";
import { generateAsyncAction } from "./generateAsyncAction";

export const setRegistrationData = registrationData => ({
  type: types.SET_REGISTRATION_DATA,
  payload: registrationData
});

export const setTotalAmount = totalAmount => ({
  type: types.SET_TOTAL_AMOUNT_TO_PAY,
  payload: totalAmount
});

export const setTotalAmountClub = totalAmountClub => ({
  type: types.SET_TOTAL_CLUB_AMOUNT_TO_PAY,
  payload: totalAmountClub
});

export const setOrderCurrency = currency => ({
  type: types.SET_ORDER_CURRENCY,
  payload: currency
});

export const getClubLLoggedUserData = request => async dispatch => {
  dispatch({ type: types.GET_CLUB_LOGGED_USER_DATA });
  const getClubLLoggedUserAction = await generateAsyncAction({
    onFailAction: getLoggedUserResultFailed,
    onSuccessAction: getLoggedUserResultSuccess,
    asyncApiMethod: getClubLoggedUserDataFromApi,
    request
  });
  return dispatch(getClubLLoggedUserAction);
};

const getLoggedUserResultSuccess = ({ payload }) => ({
  type: types.GET_CLUB_LOGGED_SUCCESS,
  payload
});

const getLoggedUserResultFailed = ({ message, title }) => ({
  type: types.GET_CLUB_LOGGED_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/registrationActions.js